/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_Erp_AInputs */



/**
* | output |
* | --- |
* | "A CSV file for your ERP with one row per customer, product and billing period. On the Billing page, choose the dates next to ERP export and click it: you get..." |
*
* @param {Partner_Faq_Erp_AInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_erp_a = /** @type {((inputs?: Partner_Faq_Erp_AInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Erp_AInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine CSV-Datei für Ihr ERP mit einer Zeile pro Kunde, Produkt und Abrechnungszeitraum. Wählen Sie auf der Abrechnungsseite die Daten neben „ERP-Export“ und klicken Sie darauf: Sie erhalten jede Abrechnung, deren Leistung zwischen diesen Daten endete. Beträge sind netto in Euro, Ihr Rabatt ist bereits abgezogen; Menge × Einzelpreis ergibt den Betrag jeder Zeile, auf den Cent gerundet.")
	return /** @type {LocalizedString} */ ("A CSV file for your ERP with one row per customer, product and billing period. On the Billing page, choose the dates next to ERP export and click it: you get every bill whose service ended between those dates. Amounts are net in euros with your discount already applied; quantity × unit price gives each row's amount, rounded to the cent.")
});